// extracted by mini-css-extract-plugin
export default {"layout":"Account_layout__7ZU2r","mainWrapper":"Account_mainWrapper__6SrET","TopNavWrapper":"Account_TopNavWrapper__wKAcy","bodyWrapper":"Account_bodyWrapper__msknr"};